<template>
  <base-modal
    width="800px"
    :modal-title="props.modalTitle"
    :confirm-text="$t('confirm')"
    :dialog-visible="dialogVisible"
    :has-confirmation-button="!!selectedImports.length"
    @confirm="confirm"
    @close="close"
  >
    <template #content>
      <base-table>
        <el-table
          ref="multipleTableRef"
          :data="props.apiNextRuns"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" />
          <el-table-column :label="$t('outputFileName')" min-width="200">
            <template #default="scope">
              {{ scope.row.outputFileName }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('apiConnectionName')" min-width="150">
            <template #default="scope">
              {{ getApiNameKey(scope.row.apiName) }}
            </template>
          </el-table-column>
        </el-table>
      </base-table>
    </template>
  </base-modal>
</template>

<script lang="ts">
import { ElTable, ElTableColumn } from 'element-plus';
import i18n from '@/i18n';
import BaseModal from '@/components/modals/BaseModal.vue';
import BaseTable from '@/components/tables/BaseTable.vue';
import { ref } from 'vue';
import { ApiImportSelection, RunApiImport } from '../models/ApiImportSelection';
import {
  ApiName,
  ApiNextRunConfiguration
} from '@etp/etp-gain-bff-client/axios';

export default {
  name: 'ApiImportSelectionModal',
  components: {
    BaseModal,
    BaseTable,
    ElTable,
    ElTableColumn
  },
  props: {
    dialogVisible: { type: Boolean },
    apiNextRuns: {
      type: Array as () => Array<ApiNextRunConfiguration>,
      default: () => []
    },
    modalTitle: { type: String, default: i18n.global.t('selectFiles') }
  },
  emits: ['confirm', 'close'],
  setup(props, { emit }) {
    let selectedImports = ref(new Array<RunApiImport>());

    const getApiNameKey = (apiName: ApiName | undefined): string => {
      if (apiName === undefined) return '';
      return (
        Object.keys(ApiName).find(
          key => ApiName[key as keyof typeof ApiName] === apiName
        ) || ''
      );
    };

    const confirm = () => {
      emit('confirm', {
        selectedImports: selectedImports.value
      } as ApiImportSelection);
    };

    const close = () => emit('close');

    const handleSelectionChange = (
      selectedRows: Array<ApiNextRunConfiguration>
    ) => {
      selectedImports.value = selectedRows
        .filter(
          row => row.apiName !== undefined && row.outputFileName !== undefined
        )
        .map(row => ({
          apiName: row.apiName ?? ApiName.Etrade,
          outputFileName: row.outputFileName ?? ''
        }));
    };

    return {
      close,
      confirm,
      getApiNameKey,
      handleSelectionChange,
      props,
      selectedImports
    };
  }
};
</script>
